import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadLean'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'リーンキャンパス フレームワーク 書き方 目的 記入例'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/download/lean/'}
        title="リーンキャンバス | 資料ダウンロード | Aitria（アイトリア）"
        description="リーンキャンバスは、スタートアップなどの事業検証に用いられ、ビジネスアイデアに対して収益モデルが成立するかを整理する際に有効なフレームワークです。事業計画の構想段階やメンバー間での検証・目線合わせにお使いください。"
      />
      <Template />
    </>
  )
}

export default Download
